/* eslint-disable camelcase */
import i18n from 'src/i18n.js';

const t = (key) => i18n.t(key);
export const Questions = () => [
    {
        id: '1',
        field_name: 'isSurgicalPlanChanged',
        question: t('reportUsage.procedure.questions.isSurgicalPlanChanged'),
    },
    {
        id: '2',
        field_name: 'isLevelOfInstrumentationChanged',
        question: t(
            'reportUsage.procedure.questions.isLevelOfInstrumentationChanged'
        ),
    },
    {
        id: '3',
        field_name: 'isChangeToInterbodiesAndOrPSOs',
        question: t(
            'reportUsage.procedure.questions.isChangeToInterbodiesAndOrPSOs'
        ),
        option_field_name: 'anyChangeToInterbodiesAndOrPSOsTxt',
        option_question: t(
            'reportUsage.procedure.optionQuestion.anyChangeToInterbodiesAndOrPSOsTxt'
        ),
        placeholder: t('reportUsage.procedure.optionQuestion.placeholder3'),
    },
    {
        id: '4',
        field_name: 'isSurgeonCutTheRod',
        question: t('reportUsage.procedure.questions.isSurgeonCutTheRod'),
        option_field_name: 'surgeonCutTheRodText',
        option_question: t(
            'reportUsage.procedure.optionQuestion.surgeonCutTheRodText'
        ),
        placeholder: t('reportUsage.procedure.optionQuestion.placeholder4'),
    },
    {
        id: '5',
        field_name: 'isRodBentInSagittalPlan',
        question: t('reportUsage.procedure.questions.isRodBentInSagittalPlan'),
        option_field_name: 'rodBentInSagittalPlanTxt',
        option_question: t(
            'reportUsage.procedure.optionQuestion.rodBentInSagittalPlanTxt'
        ),
        placeholder: t('reportUsage.procedure.optionQuestion.placeholder5'),
    },
    {
        id: '6',
        field_name: 'isSurgeonSatisfied',
        question: t('reportUsage.procedure.questions.isSurgeonSatisfied'),
    },
    {
        id: '7',
        field_name: 'pjkMdtInstructed',
        question: t('reportUsage.procedure.questions.pjkMdtInstructed'),
    },
    {
        id: '8',
        field_name: 'pjkMdtImplants',
        question: t('reportUsage.procedure.questions.pjkMdtImplants'),
    },
];

export const pjkUsageQuestions = () => [
    {
        id: '1',
        field_name: 'isSurgicalPlanChanged',
        question: t('reportUsage.procedure.questions.isSurgicalPlanChanged'),
    },
    {
        id: '2',
        field_name: 'isLevelOfInstrumentationChanged',
        question: t(
            'reportUsage.procedure.questions.isLevelOfInstrumentationChanged'
        ),
    },
    {
        id: '3',
        field_name: 'isChangeToInterbodiesAndOrPSOs',
        question: t(
            'reportUsage.procedure.questions.isChangeToInterbodiesAndOrPSOs'
        ),
        option_field_name: 'anyChangeToInterbodiesAndOrPSOsTxt',
        option_question: t(
            'reportUsage.procedure.optionQuestion.anyChangeToInterbodiesAndOrPSOsTxt'
        ),
        placeholder: t('reportUsage.procedure.optionQuestion.placeholder3'),
    },
    {
        id: '4',
        field_name: 'isSurgeonCutTheRod',
        question: t('reportUsage.procedure.questions.isSurgeonCutTheRod'),
        option_field_name: 'surgeonCutTheRodText',
        option_question: t(
            'reportUsage.procedure.optionQuestion.surgeonCutTheRodText'
        ),
        placeholder: t('reportUsage.procedure.optionQuestion.placeholder4'),
    },
    {
        id: '5',
        field_name: 'isRodBentInSagittalPlan',
        question: t('reportUsage.procedure.questions.isRodBentInSagittalPlan'),
        option_field_name: 'rodBentInSagittalPlanTxt',
        option_question: t(
            'reportUsage.procedure.optionQuestion.rodBentInSagittalPlanTxt'
        ),
        placeholder: t('reportUsage.procedure.optionQuestion.placeholder5'),
    },
    {
        id: '6',
        field_name: 'isSurgeonSatisfied',
        question: t('reportUsage.procedure.questions.isSurgeonSatisfied'),
    },
    {
        id: '7',
        field_name: 'pjkPerformed',
        question: t('reportUsage.procedure.questions.pjkPerformed'),
    },
];

export const questionAfterPjk = () => [
    {
        id: '8',
        field_name: 'pjkMdtInstructed',
        question: t('reportUsage.procedure.questions.pjkMdtInstructed'),
    },
    {
        id: '8',
        field_name: 'pjkMdtImplants',
        question: t('reportUsage.procedure.questions.pjkMdtImplants'),
    },
];

export const DropDownOption = [
    'C1',
    'C2',
    'C3',
    'C4',
    'C5',
    'C6',
    'C7',
    'T1',
    'T2',
    'T3',
    'T4',
    'T5',
    'T6',
    'T7',
    'T8',
    'T9',
    'T10',
    'T11',
    'T12',
    'L1',
    'L2',
    'L3',
    'L4',
    'L5',
    'S1',
    'S2',
    'lllium',
];
